'use client'

import { ImageHelper } from '@/lib/helpers/image.helper'
import { cn } from '@/lib/utils'
import { ChevronRight } from 'lucide-react'
import { useEffect, useMemo, useRef, useState } from 'react'
import { ImageWithFallback as Image } from '../image-with-fallback'
import { useProductCardContext } from './context/product-card-context'

export const ProductItemVariantMobile = () => {
  const { product, selectedColor, onChangeColorVariant } =
    useProductCardContext()

  const colors = useMemo(() => {
    return Object.entries(product?.mapped_variants ?? {})
  }, [product?.mapped_variants])

  const scrollRef = useRef<HTMLDivElement>(null)
  const [showArrow, setShowArrow] = useState(false)

  useEffect(() => {
    const checkOverflow = () => {
      const el = scrollRef.current
      if (!el) return
      setShowArrow(el.scrollWidth > el.clientWidth)
    }

    checkOverflow()

    const debouncedCheckOverflow = () => {
      let timeoutId: NodeJS.Timeout
      return () => {
        clearTimeout(timeoutId)
        timeoutId = setTimeout(checkOverflow, 100)
      }
    }

    const handleResize = debouncedCheckOverflow()
    window.addEventListener('resize', handleResize)
    return () => window.removeEventListener('resize', handleResize)
  }, [colors])

  const handleScrollRight = () => {
    if (scrollRef.current) {
      scrollRef.current.scrollBy({
        left: 60,
        behavior: 'smooth',
      })
    }
  }

  if (colors.length === 0) return null

  return (
    <div className='relative pr-6'>
      <div
        ref={scrollRef}
        className='color-variant-picker-wrapper no-scrollbar flex h-6 w-full items-center gap-1.5 overflow-auto px-0.5 pb-0.5'
        role='listbox'
        aria-label='Chọn màu sắc sản phẩm'
      >
        {colors.map(([color, variants], index) => (
          <button
            key={index}
            className={cn(
              'color-variant-picker h-[17px] w-[30px] min-w-[30px] rounded-full bg-center bg-no-repeat ring-1 ring-neutral-400 ring-offset-1',
              selectedColor === color && 'ring-primary'
            )}
            style={{
              backgroundImage: `url('${ImageHelper.getImageUrl(
                variants[0].colorImage,
                '',
                160,
                160,
                85
              )}')`,
            }}
            title={color}
            aria-label={`Chọn màu ${color}`}
            onClick={() => onChangeColorVariant({ color, variants })}
            role='option'
            aria-selected={selectedColor === color}
          >
            <Image
              src={ImageHelper.getImageUrl(
                variants[0].colorImage,
                '',
                160,
                160,
                85
              )}
              alt={color}
              width={160}
              height={160}
              className='h-full w-full rounded-full object-cover'
            />
          </button>
        ))}
      </div>

      {showArrow && (
        <button
          className='color-variant-picker-arrow absolute -right-0.5 top-0 z-10 h-5.5 w-5 bg-light'
          onClick={handleScrollRight}
          aria-label='Xem thêm màu sắc'
        >
          <ChevronRight className='text-neutral-400' aria-hidden='true' />
        </button>
      )}
    </div>
  )
}
